import { DAY_NAMES, formatBusinessHour, weekOrdered } from '../../utils/hours'
import { cn } from '../../utils/cn'
import type { BusinessHour } from '../../types/storefront'

export interface BusinessHoursProps {
  hours: BusinessHour[]
  className?: string
}

export function BusinessHours({ hours, className }: BusinessHoursProps) {
  const week = weekOrdered(hours)
  if (!week.length) {
    return (
      <p className={cn('font-body-md text-body-md text-on-surface-variant', className)}>
        Call the salon for opening hours.
      </p>
    )
  }

  const today = new Date().getDay()

  return (
    <ul className={cn('flex flex-col gap-2', className)}>
      {week.map((hour) => {
        const closed = !hour.is_open || !hour.open_time || !hour.close_time
        return (
          <li
            key={hour.day}
            className={cn(
              'flex justify-between gap-6 font-body-md text-body-md',
              hour.day === today ? 'text-on-surface' : 'text-on-surface-variant',
            )}
          >
            <span className={cn(hour.day === today && 'font-bold')}>
              {DAY_NAMES[hour.day]}
            </span>
            <span>{closed ? 'Closed' : formatBusinessHour(hour)}</span>
          </li>
        )
      })}
    </ul>
  )
}
